import { EmployeeSummaryDto } from './employee-summary-dto.model';
import { TransactionStatus } from '../service-proxies';


export class ResignApplicationDto implements IResignApplicationDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    resignDate!: Date | undefined;
    approver!: EmployeeSummaryDto;
    reason!: string | undefined;
    resignStatus!: TransactionStatus;
    statusRemark!: string | undefined;
    resignStatusType!: string | undefined;
    noticePeriodStartDate!: Date | undefined;
    noticePeriodEndDate!: Date | undefined;
    calcRevivedPaidLeave!: boolean;
    calcRevivedIncreement!: boolean;
    topLeader!: number;

    constructor(data?: IResignApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.resignDate = _data["resignDate"] ? new Date(_data["resignDate"].toString()) : <any>undefined;
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.reason = _data["reason"];
            this.resignStatus = _data["resignStatus"];
            this.statusRemark = _data["statusRemark"];
            this.resignStatusType = _data["resignStatusType"];
            this.noticePeriodStartDate = _data["noticePeriodStartDate"] ? new Date(_data["noticePeriodStartDate"].toString()) : <any>undefined;
            this.noticePeriodEndDate = _data["noticePeriodEndDate"] ? new Date(_data["noticePeriodEndDate"].toString()) : <any>undefined;
            this.calcRevivedPaidLeave = _data["calcRevivedPaidLeave"];
            this.calcRevivedIncreement = _data["calcRevivedIncreement"];
            this.topLeader = _data["topLeader"];
        }
    }

    static fromJS(data: any): ResignApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResignApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["resignDate"] = this.resignDate ? this.resignDate.toISOString() : <any>undefined;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["reason"] = this.reason;
        data["resignStatus"] = this.resignStatus;
        data["statusRemark"] = this.statusRemark;
        data["resignStatusType"] = this.resignStatusType;
        data["noticePeriodStartDate"] = this.noticePeriodStartDate ? this.noticePeriodStartDate.toISOString() : <any>undefined;
        data["noticePeriodEndDate"] = this.noticePeriodEndDate ? this.noticePeriodEndDate.toISOString() : <any>undefined;
        data["calcRevivedPaidLeave"] = this.calcRevivedPaidLeave;
        data["calcRevivedIncreement"] = this.calcRevivedIncreement;
        data["topLeader"] = this.topLeader;
        return data; 
    }
}

export interface IResignApplicationDto {
    id: number;
    employee: EmployeeSummaryDto;
    resignDate: Date | undefined;
    approver: EmployeeSummaryDto;
    reason: string | undefined;
    resignStatus: TransactionStatus;
    statusRemark: string | undefined;
    resignStatusType: string | undefined;
    noticePeriodStartDate: Date | undefined;
    noticePeriodEndDate: Date | undefined;
    calcRevivedPaidLeave: boolean;
    calcRevivedIncreement: boolean;
    topLeader: number;
}

